function confirmable(e, msg) {
  if (confirm(msg) != true) {
    e.preventDefault();
    e.stopImmediatePropagation();

    return;
  }
}

export function initConfirmable(targetEl) {
  const target = targetEl || document;
  target.querySelectorAll('[data-confirmable]').forEach((form) => {
    const msg = form.dataset.confirmable || 'Are you sure you want to do this?';
    form.addEventListener('submit', e => confirmable(e, msg));
  });
}
